import { useEffect, useState } from 'react';
import { BiDollar } from 'react-icons/bi';
import { FaWeight } from 'react-icons/fa';
import { useFetchData } from '../../../../../hooks/useFetchData';
import ReactApexChart from 'react-apexcharts';

const TransactionContributions = () => {
  const { data, loading, error } = useFetchData("mandoub/stats?scope=transactions");
  const [chartData, setChartData] = useState({
    series: [
      {
        name: 'العسل المباع (كجم)',
        type: 'column',
        data: [],
      }
    ],
  });

  const [options, setOptions] = useState({
    chart: {
      parentHeightOffset: 0,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 7,
        columnWidth: '35%',
        colors: {
          ranges: [{ to: 50, from: 40, color: 'var(--purple)' }]
        }
      }
    },
    tools: { download: true },
    markers: {
      size: 3.5,
      strokeWidth: 2,
      fillOpacity: 1,
      strokeOpacity: 1,
      colors: 'white',
      strokeColors: 'var(--purple)',
    },
    stroke: {
      width: [0, 2],
      colors: ['var(--purple-light)', 'var(--purple)'],
    },
    legend: { show: false },
    dataLabels: { enabled: false },
    colors: ['var(--purple-light)'],
    grid: {
      strokeDashArray: 7,
      borderColor: '#a8aab4',
      padding: { left: -2, right: 8 }
    },
    states: {
      hover: { filter: { type: 'none' } },
      active: { filter: { type: 'none' } }
    },
    xaxis: {
      categories: [],
      tickPlacement: 'on',
      labels: { show: false },
      axisTicks: { show: false },
      axisBorder: { show: false }
    },
    yaxis: {
      min: 0,
      max: 100,
      show: true,
      tickAmount: 3,
      labels: {
        formatter: value => `${value.toFixed(1)} كجم`,
        offsetX: -10,
        style: {
          fontSize: '0.8125rem',
          colors: 'var(--text)',
        }
      }
    }
  });

  useEffect(() => {
    if (data && data.success && data.trans) {
      // Sort and get 5 most recent transactions
      const recentTrans = [...data.trans]
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 5)
        .reverse();

      const quantities = recentTrans.map(t => t.qte);
      const prices = recentTrans.map(t => t.qte * 2);
      const days = recentTrans.map(t => 
        new Intl.DateTimeFormat('ar-SA', { weekday: 'long' }).format(new Date(t.createdAt))
      );

      setChartData({
        series: [
          {
            name: 'العسل المباع (كجم)',
            type: 'column',
            data: quantities,
          },
          
        ],
      });

      setOptions(prev => ({
        ...prev,
        xaxis: {
          ...prev.xaxis,
          categories: days
        }
      }));
    }
  }, [data]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error loading data</div>;

  const totalQuantity = data?.trans?.reduce((sum, t) => sum + t.qte, 0) || 0;
  const totalIncome = data?.trans?.reduce((sum, t) => sum + (t.qte * 1), 0) || 0;

  return (
    <div className='section-card flex1 !w-full' style={{ width: "-webkit-fill-available !important", borderRadius: "1rem" }} dir='rtl'>
      <div dir='rtl' className='df-c'>
        <div className="title">المعاملات</div>
        <div className="df-c">
          <div className="df !gap-2">
            <div className="rounded-icon !w-10 !h-10 !rounded-md">
              <FaWeight />
            </div>
            <div className="df-c g0">
              <div className='text-black font-bold'>{totalQuantity} كجم</div>
              <div className='text'>إجمالي الوزن</div>
            </div>
           
          </div>
          {data &&<div className="df">
            <div className="rounded-icon pinked !w-10 !h-10 !rounded-md">
              <BiDollar />
            </div>
            <div className="df-c g0" dir="rtl">
              <div className="text-black font-bold">
                {data?.trans?.length} معاملة
              </div>
              <div className="text">
                إجمالي المعاملات
              </div>
            </div>

          
          </div>}
        </div>
      </div>
      <div id='chart' className='w-full df-c ai-center'>
        <ReactApexChart
          type='line' 
          height={200} 
          style={{ width: "100%" }}
          series={chartData.series} 
          options={options} 
        />
      </div>
    </div>
  );
};

export default TransactionContributions;